import React, { Component } from 'react';

const VariantSelector = (props) => {
  const { product, handleVariantChange } = props;
  let variants = product.variants.filter((variant) => variant.available);

  return (
    <div className="select-wrapper">
      <select className="Product__option" onChange={handleVariantChange} tabIndex={0}>
        {variants.map((variant) => {
          return <option value={variant.id} key={variant.id}>{`${variant.title}`}</option>;
        })}
      </select>
      <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
        <use href="#down"></use>
      </svg>
    </div>
  );
};

export default VariantSelector;
